module.exports = {"attributes":{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"},"content":"<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.60587 5.42405C5.59044 4.43949 6.9258 3.88636 8.31818 3.88636C9.11332 3.88636 9.8342 4.00002 10.5383 4.30671C11.0483 4.52882 11.5248 4.84144 12 5.24901C12.4752 4.84144 12.9517 4.52882 13.4617 4.30671C14.1658 4.00002 14.8867 3.88636 15.6818 3.88636C17.0742 3.88636 18.4096 4.43949 19.3941 5.42405C20.3787 6.40862 20.9318 7.74398 20.9318 9.13636C20.9318 11.3489 19.4718 12.9767 18.2549 14.1694L12.5303 19.894C12.2374 20.1869 11.7626 20.1869 11.4697 19.894L5.74686 14.1712C4.51632 12.9811 3.06818 11.3553 3.06818 9.13636C3.06818 7.74398 3.62131 6.40862 4.60587 5.42405ZM8.31818 5.38636C7.32362 5.38636 6.36979 5.78145 5.66653 6.48471C4.96327 7.18797 4.56818 8.1418 4.56818 9.13636C4.56818 10.6783 5.57098 11.9149 6.79399 13.0971L6.80313 13.106L6.80306 13.106L12 18.303L17.1969 13.106L17.2023 13.1006L17.2024 13.1007C18.4231 11.9045 19.4318 10.6695 19.4318 9.13636C19.4318 8.1418 19.0367 7.18797 18.3335 6.48471C17.6302 5.78145 16.6764 5.38636 15.6818 5.38636C15.037 5.38636 14.5306 5.47725 14.0606 5.68193C13.5858 5.88872 13.1012 6.23217 12.5303 6.80306C12.2374 7.09595 11.7626 7.09595 11.4697 6.80306C10.8988 6.23217 10.4142 5.88872 9.93938 5.68193C9.46943 5.47725 8.96304 5.38636 8.31818 5.38636Z\" fill=\"currentColor\"/>"}
const React = require('react');

function svgLoader(svg) {
	const { viewBox, width, height } = svg.attributes;

	// eslint-disable-next-line react/display-name
	return function (props) {
		return React.createElement(
			'svg',
			Object.assign(
				{
					dangerouslySetInnerHTML: { __html: svg.content },
					fill: 'currentColor',
					height,
					viewBox,
					width,
				},
				props,
			),
		);
	};
}

module.exports = svgLoader(module.exports);
